module.exports = __webpack_public_path__ + "img/American-First-Health---Logo-Design---final---high-resolution---1-320w.a49e4505.png";